import { render } from "./SwdAvatar.vue?vue&type=template&id=fb1c0758"
import script from "./SwdAvatar.vue?vue&type=script&lang=js"
export * from "./SwdAvatar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__